import { MenuProps } from 'antd';
import { Link } from 'react-router';
import {
  DashboardOutlined,
  TeamOutlined,
  CheckSquareOutlined,
  MobileOutlined,
  FileExcelOutlined,
  CarryOutOutlined,
  ProfileOutlined,
  InboxOutlined,
  BookOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  ReadOutlined,
  ScheduleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import {
  globalPaths,
  devicesPaths,
  genericPaths,
  incidencePaths,
  kardexPaths,
  reportPaths,
  usersPaths,
} from './routePaths';
import { AdminRole, EmployeeRole, SupportRole, UserRoles } from './enums/roles';
import Contract from 'types/contract';

export const DashboardItem = {
  label: <Link to={globalPaths.basePath}>Dashboard</Link>,
  key: globalPaths.basePath,
  icon: <DashboardOutlined />,
};

export const EmployeesItem = {
  label: <Link to={usersPaths.basePath}>Empleados</Link>,
  key: usersPaths.basePath,
  icon: <TeamOutlined />,
};

export const ReportsItem = {
  label: 'Reportes',
  key: reportPaths.basePath,
  icon: <FileExcelOutlined />,
  children: [
    {
      label: (
        <Link to={`${reportPaths.basePath}/${reportPaths.checks}`}>
          Chequeos
        </Link>
      ),
      key: `${reportPaths.basePath}/${reportPaths.checks}`,
      icon: <CheckSquareOutlined />,
    },
    {
      label: (
        <Link to={`${reportPaths.basePath}/${reportPaths.events}`}>
          Eventos
        </Link>
      ),
      key: `${reportPaths.basePath}/${reportPaths.events}`,
      icon: <CarryOutOutlined />,
    },
    {
      label: (
        <Link to={`${reportPaths.basePath}/${reportPaths.incidences}`}>
          Incidencias
        </Link>
      ),
      key: `${reportPaths.basePath}/${reportPaths.incidences}`,
      icon: <ProfileOutlined />,
    },
  ],
};

export const subMenuKeys = ['chequeos', 'eventos', 'incidencias']; // solo para keys de sub menú como las de reportes

const myIncidenceRequestsKey = `/${genericPaths.employeeIncidenceRequests}`;
const incidenceAuthorizationsKey = `${incidencePaths.basePath}/${incidencePaths.authorizations}`;

export const AdminIncidencesItem = {
  label: 'Incidencias',
  key: incidencePaths.basePath,
  icon: <BookOutlined />,
  children: [
    {
      label: (
        <Link to={`${incidencePaths.basePath}/${incidencePaths.catalogue}`}>
          Catálogo
        </Link>
      ),
      key: `${incidencePaths.basePath}/${incidencePaths.catalogue}`,
      icon: <BookOutlined />,
    },
    {
      label: (
        <Link to={`/${genericPaths.employeeIncidenceRequests}`}>
          Mis solicitudes
        </Link>
      ),
      key: myIncidenceRequestsKey,
      icon: <InboxOutlined />,
    },
    {
      label: (
        <Link
          to={`${incidencePaths.basePath}/${incidencePaths.authorizations}`}
        >
          Autorizaciones
        </Link>
      ),
      key: incidenceAuthorizationsKey,
      icon: <CarryOutOutlined />,
    },
  ],
};

export const DevicesItem = {
  label: <Link to={devicesPaths.basePath}>Dispositivos</Link>,
  key: devicesPaths.basePath,
  icon: <MobileOutlined />,
};

export const SelfKardexItem = {
  label: <Link to={`${kardexPaths.base}/${kardexPaths.self}`}>Mi kardex</Link>,
  key: `${kardexPaths.base}/${kardexPaths.self}`,
  icon: <CalendarOutlined />,
};

export const SelfChecksItem = {
  label: <Link to={`/${genericPaths.employeeSelfChecks}`}>Mis chequeos</Link>,
  key: `/${genericPaths.employeeSelfChecks}`,
  icon: <CheckSquareOutlined />,
};

export const EmployeeIncidencesItem = {
  label: 'Incidencias',
  key: 'employee-incidences',
  icon: <ProfileOutlined />,
  children: [
    {
      label: (
        <Link to={`/${genericPaths.employeeIncidenceRequests}`}>
          Mis solicitudes
        </Link>
      ),
      key: myIncidenceRequestsKey,
      icon: <InboxOutlined />,
    },
    {
      label: (
        <Link to={`${incidencePaths.basePath}/${incidencePaths.approvals}`}>
          Aprobaciones
        </Link>
      ),
      key: `${incidencePaths.basePath}/${incidencePaths.approvals}`,
      icon: <CarryOutOutlined />,
    },
  ],
};

export const GlobalHolidaysList = {
  label: <Link to={`/${globalPaths.holidaysList}`}>Días festivos</Link>,
  key: `/${globalPaths.holidaysList}`,
  icon: <CalendarOutlined />,
};

export const HolidaysItem = {
  label: 'Días festivos',
  key: globalPaths.holidaysList,
  icon: <CalendarOutlined />,
  children: [
    {
      label: (
        <Link to={`/${globalPaths.holidaysList}`}>Lista de días festivos</Link>
      ),
      key: `/${globalPaths.holidaysList}`,
      icon: <ScheduleOutlined />,
    },
    {
      label: (
        <Link to={`/${globalPaths.holidays}`}>Catálogo de días festivos</Link>
      ),
      key: `/${globalPaths.holidays}`,
      icon: <BookOutlined />,
    },
  ],
};

export const ScheduleItem = {
  label: 'Horarios',
  key: 'schedule',
  icon: <ClockCircleOutlined />,
  children: [
    {
      label: <Link to={`/${globalPaths.careers}`}>Carreras</Link>,
      key: 'careers',
      icon: <ReadOutlined />,
    },
    {
      label: <Link to={`/${globalPaths.cycles}`}>Ciclos</Link>,
      key: 'cycles',
      icon: <ScheduleOutlined />,
    },
    {
      label: <Link to={`/${globalPaths.groups}`}>Grupos</Link>,
      key: 'groups',
      icon: <TeamOutlined />,
    },
    {
      label: <Link to={`/${globalPaths.subjects}`}>Materias</Link>,
      key: 'subjects',
      icon: <ScheduleOutlined />,
    },
  ],
};

const AdminHelpItem = {
  label: (
    <a
      href={'https://prosinergia.mx/ayuda/categoria/administradores'}
      target="_blank"
    >
      Ayuda
    </a>
  ),
  key: `ayuda-admins`,
  icon: <QuestionCircleOutlined />,
};
const SupportHelpItem = {
  label: (
    <a href={'https://prosinergia.mx/ayuda/categoria/tecnico'} target="_blank">
      Ayuda
    </a>
  ),
  key: `ayuda-soporte`,
  icon: <QuestionCircleOutlined />,
};
const EmployeeHelpItem = {
  label: (
    <a href={'https://prosinergia.mx/ayuda/categoria/docentes'} target="_blank">
      Ayuda
    </a>
  ),
  key: `ayuda-employee`,
  icon: <QuestionCircleOutlined />,
};

const adminRoleMenuItemsBase: NonNullable<MenuProps['items']> = [
  DashboardItem,
  EmployeesItem,
  ReportsItem,
  AdminIncidencesItem,
  DevicesItem,
  SelfKardexItem,
  HolidaysItem,
];

export const SupportRoleMenuItems: MenuProps['items'] = [
  DevicesItem,
  SelfKardexItem,
  GlobalHolidaysList,
  SupportHelpItem,
];

const employeeRoleMenuItemsBase: NonNullable<MenuProps['items']> = [
  EmployeeIncidencesItem,
  SelfKardexItem,
  GlobalHolidaysList,
];

const getAdminRoleMenuItems = (
  isIncidencesModuleEnabled: boolean,
  isMyIncidenceRequestsEnabled: boolean,
  isIncidenceAuthorizationsEnabled: boolean
): NonNullable<MenuProps['items']> => {
  if (isIncidencesModuleEnabled) {
    if (isMyIncidenceRequestsEnabled && isIncidenceAuthorizationsEnabled) {
      return adminRoleMenuItemsBase;
    }

    return adminRoleMenuItemsBase.map((item) => {
      if (
        !item ||
        item.key !== incidencePaths.basePath ||
        !('children' in item)
      ) {
        return item;
      }

      const hiddenKeys = [
        !isMyIncidenceRequestsEnabled ? myIncidenceRequestsKey : null,
        !isIncidenceAuthorizationsEnabled ? incidenceAuthorizationsKey : null,
      ];

      return {
        ...item,
        children:
          item.children?.filter(
            (childItem) =>
              childItem && !hiddenKeys.includes(childItem.key as string)
          ) ?? [],
      };
    });
  }

  return adminRoleMenuItemsBase
    .map((item) => {
      if (!item) {
        return item;
      }

      if (item.key === incidencePaths.basePath) {
        return null;
      }

      return item;
    })
    .filter(Boolean) as NonNullable<MenuProps['items']>;
};

const getEmployeeRoleMenuItems = (
  isIncidencesModuleEnabled: boolean,
  isMyIncidenceRequestsEnabled: boolean,
  isSupervisor = false
): NonNullable<MenuProps['items']> => {
  if (isIncidencesModuleEnabled) {
    return employeeRoleMenuItemsBase
      .map((item) => {
        if (
          !item ||
          item.key !== 'employee-incidences' ||
          !('children' in item)
        ) {
          return item;
        }

        const hiddenKeys = [
          !isMyIncidenceRequestsEnabled ? myIncidenceRequestsKey : null,
          !isSupervisor
            ? `${incidencePaths.basePath}/${incidencePaths.approvals}`
            : null,
        ];
        const filteredChildren =
          item.children?.filter(
            (childItem) =>
              childItem && !hiddenKeys.includes(childItem.key as string)
          ) ?? [];

        if (filteredChildren.length === 0) {
          return null;
        }

        return {
          ...item,
          children: filteredChildren,
        };
      })
      .filter(Boolean) as NonNullable<MenuProps['items']>;
  }

  return employeeRoleMenuItemsBase.filter(
    (item) => item && item.key !== 'employee-incidences'
  );
};

export const getMenuItems = (
  userRole: UserRoles,
  isSupervisor: boolean,
  contracts: Contract[],
  isSchedulesModuleEnabled: string,
  isIncidencesModuleEnabled: string,
  isMyIncidenceRequestsEnabled: string,
  isIncidenceAuthorizationsEnabled: string
) => {
  const isScheduleItemEnabled = JSON.parse(isSchedulesModuleEnabled);
  const isIncidenceItemEnabled = JSON.parse(isIncidencesModuleEnabled);
  const isMyIncidenceRequestsItemEnabled = JSON.parse(
    isMyIncidenceRequestsEnabled || 'true'
  );
  const isIncidenceAuthorizationsItemEnabled = JSON.parse(
    isIncidenceAuthorizationsEnabled || 'true'
  );
  switch (userRole) {
    case AdminRole: {
      const adminItems = getAdminRoleMenuItems(
        isIncidenceItemEnabled,
        isMyIncidenceRequestsItemEnabled,
        isIncidenceAuthorizationsItemEnabled
      );
      if (isScheduleItemEnabled) {
        return [...adminItems, ScheduleItem, AdminHelpItem];
      }
      return [...adminItems, AdminHelpItem];
    }
    case SupportRole:
      return SupportRoleMenuItems;
    case EmployeeRole:
      return [
        ...getEmployeeRoleMenuItems(
          isIncidenceItemEnabled,
          isMyIncidenceRequestsItemEnabled,
          isSupervisor
        ),
        SelfChecksItem,
        EmployeeHelpItem,
      ];
    default:
      return getEmployeeRoleMenuItems(
        isIncidenceItemEnabled,
        isMyIncidenceRequestsItemEnabled,
        isSupervisor
      );
  }
};
